module.exports = __webpack_public_path__ + "media/images/icons/twitter-03b1798fdb6906ec49aef0e0b4b7550b.svg";